import { Button, DialogActions, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material'
import { useParams } from 'react-router-dom'
import StartIcon from '@mui/icons-material/PlayArrow'
import axios from 'axios'
import React from 'react'
import Typography from '@mui/material/Typography'
import ScenarioList from '../../scenario/ScenarioList'
import { MemoScenarioDashboard } from '../../charts/ScenarioDashboard'
import Box from '@mui/material/Box'
import ButtonDialog from '../../shared/ButtonDialog'

interface Props {
	visible: boolean
	simulation: any
	setSimulation: any
}

export default function Scenarios({ visible, simulation, setSimulation }: Props) {
	const { name } = useParams()

	const [error, setError] = React.useState<any>(undefined)
	const [open, setOpen] = React.useState<boolean>(false)
	const [val, setVal] = React.useState<any>(undefined)
	const [scenario, setScenario] = React.useState<any>(undefined)

	const checkStartScenario = () => {
		if (!(simulation?.scenario && Object.keys(simulation.scenario).length > 0)) return false
		return true
	}

	const getDialogContent = () => {
		return checkStartScenario() ? (
			<>
				<Typography variant='body2'>
					Are you sure you want to run this scenario? Depending on the time duration and the number of config
					parameters, this could take a while.
				</Typography>
				<FormControl size='small' sx={{ width: '100%', mt: 2.5 }}>
					<InputLabel>Scenario</InputLabel>
					<Select
						value={val}
						label='Scenario'
						onChange={(e) => {
							setVal(e.target.value)
						}}
					>
						{Object.keys(simulation.scenario).map((key) => (
							<MenuItem key={key} value={key}>
								{key}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<DialogActions sx={{ p: 0, pt: 2 }}>
					<Button onClick={() => setOpen(false)}>Cancel</Button>
					<Button
						onClick={async () => {
							try {
								setError(undefined)
								setOpen(false)
								simulation.status = { running: true, progress: 0.0 }
								setSimulation({ ...simulation })
								await axios.get(`${process.env.REACT_APP_API}/${name}/run/${val}`, {
									withCredentials: true
								})
							} catch (err: any) {
								const error = err
								if (error.response.data._error) setError(error.response.data._error)
								simulation.status = { running: false, progress: 0.0, error: error.response.data._error }
								setSimulation({ ...simulation })
							}
						}}
					>
						Run
					</Button>
				</DialogActions>
			</>
		) : (
			<>
				<Typography variant='body2'>
					You currently have no scenarios, after creating a new scenario you will be able to run it.
				</Typography>

				<DialogActions sx={{ p: 0, pt: 1 }}>
					<Button onClick={() => setOpen(false)}>Ok</Button>
				</DialogActions>
			</>
		)
	}

	return (
		<Stack
			sx={{
				display: visible ? 'flex' : 'none'
			}}
		>
			<ButtonDialog
				disabled={simulation?.status?.running}
				title={`Run Scenario`}
				icon={<StartIcon />}
				content={getDialogContent()}
				open={open}
				setOpen={(bool) => {
					setOpen(bool)
					setVal(simulation?.scenario ? Object.keys(simulation?.scenario)[0] : undefined)
				}}
			/>

			<Typography variant='caption' color='error' sx={{ mx: 2, mt: -1 }}>
				{error || simulation?.status?.error}
			</Typography>

			<ScenarioList
				disabled={simulation?.status?.running}
				simulation={simulation}
				data={Object.entries(simulation?.scenario || []).map((b) => {
					const name = b[0]
					const val = b[1] as object
					return Object.assign(val, { name: name } as object)
				})}
				setData={setSimulation}
				scenario={scenario}
				setScenario={setScenario}
			/>
			<Box sx={{ p: 2 }}>
				<MemoScenarioDashboard setError={setError} scenario={scenario} />
			</Box>
		</Stack>
	)
}
